import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js'
// import { useChartResizeEffect } from './chartRefs'

// Registrar los componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
)

const KpiCustomGraphicLine = ({
  lineData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'Sales',
        data: [10, 20, 15, 25, 30, 35, 40],
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        tension: 0, // Suavizar las líneas
      },
    ],
  },
  lineOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Months',
        },
        ticks: {
          callback: function (value) {
            return value.toFixed(2) // Asegurar dos decimales
          },
        },
      },
      y: {
        title: {
          display: true,
          text: 'Values',
        },
        beginAtZero: true,
      },
    },
  },
  fromPdf = false,
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const chartRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      if(!fromPdf){
        setIsMobile(window.innerWidth <= 768) // Detectar vista móvil
        // Forzar resize del gráfico en cada cambio de tamaño
        if (chartRef.current) {
          if (typeof chartRef.current.resize === 'function') {
            chartRef.current.resize()
          } else if (
            chartRef.current.chartInstance &&
            typeof chartRef.current.chartInstance.resize === 'function'
          ) {
            chartRef.current.chartInstance.resize()
          }
        }
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const mobileLineOptions = {
    ...lineOptions,
    plugins: {
      ...lineOptions?.plugins,
      legend: {
        ...lineOptions?.plugins?.legend,
        position: 'bottom', // Cambiar posición de la leyenda en móvil
      },
      datalabels: {
        ...lineOptions?.plugins?.datalabels,
        anchor: 'end',
        align: 'end',
        offset: -10, // Posicionar los valores dentro de las barras
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Fondo negro semi-transparente
        borderRadius: 4, // Bordes redondeados
        color: '#FFFFFF', // Color del texto
        font: {
          size: 10, // Tamaño pequeño de la letra
        },
      },
    },
    scales: {
      ...lineOptions?.scales,
      // x: {
      //   ...lineOptions?.scales?.x,
      //   ticks: {
      //     display: false, // Ocultar etiquetas en el eje X
      //   },
      // },
      // y: {
      //   ...lineOptions?.scales?.y,
      //   ticks: {
      //     display: false, // Ocultar etiquetas en el eje Y
      //   },
      // },
    },
  }

  // useChartResizeEffect('.kpi-graphics canvas')
  return (
    <div className="px-1 kpi-graphics">
      <div className="row kpi-card-container kpi-card-containerMini">
        {lineData && lineOptions && (
          <Line ref={chartRef} data={lineData} options={isMobile ? mobileLineOptions : lineOptions} />
        )}
      </div>
    </div>
  )
}

KpiCustomGraphicLine.propTypes = {
  lineData: PropTypes.object,
  lineOptions: PropTypes.object,
}

export default KpiCustomGraphicLine
